import _ from 'lodash';

export const selectRecentActivity = state => _.get(state, ['recentActivity'], {});

